export default {
  searching: 'A procurar',
}
